(function() {
    'use strict';

    angular.module('app').directive('fodbzHelpedLabelRequired', FodbzHelpedLabelRequiredDirective);
    function FodbzHelpedLabelRequiredDirective() {
        return {
            transclude: true,
            scope: {
                fodbzField: '@',
                fodbzResource: '@',
                fodbzInfo: '@',
            },
            template: `<fodbz-label-required fodbz-field="{{fodbzField}}" fodbz-resource="{{fodbzResource}}">
                &nbsp;
                <fodbz-info-sign fodbz-info="{{fodbzInfo}}"></fodbz-info-sign>
            </fodbz-label>`
        };
    }
})();